module.exports = __webpack_public_path__ + "static/join-ce75888fa3299d1111e842d2a1c06643.gif";